import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";

export default function PrivateRoute({ children, role }) {
    const isLoggedIn = useAuth(role);

    return isLoggedIn ? children : <Navigate to="/" />;
}